export default __webpack_public_path__ + "static/media/equity-logo.00fbfc22.png";